export default "__VITE_ASSET__DysVH3Bj__"